// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"179":"a333f25d","331":"0a74ce08","691":"b40b23b1","796":"0f00041f"}[chunkId] + ".chunk.css";
};